module.exports = __webpack_public_path__ + "img/PL08304.6cb02c58.png";